var ListHelper = (function ($) {

	/**
	 * Map Helper
	 * @param {dom element - container for list object } pickupListCanvas
	 * @param {get html template for pickup point list item (function)} getPickupInfoHtml
	 * @param {called after marker was selected (function)} currentChanged 
	 * @returns {List Helper object} 
	 */
	function list(pickupListCanvas, getPickupInfoHtml, getNoPickupMessageHtml, currentChanged) {

		this.pickupListCanvas = pickupListCanvas;

		this.getPickupInfoHtml = getPickupInfoHtml || this.getPickupInfoHtml;
		this.getNoPickupMessageHtml = getNoPickupMessageHtml || this.getNoPickupMessageHtml;
		this.currentChanged = currentChanged || this.currentChanged;

	}

	list.prototype = {
		addPickupPoints: function (pickupPoints) {
			this.pickupListCanvas.innerHTML = '';

			if (!pickupPoints.length) {
				this.pickupListCanvas.innerHTML = this.getNoPickupMessageHtml();
			}

			for (var i = 0; i < pickupPoints.length; i++) {
				pickupPoints[i] && this._addPickupPoint(pickupPoints[i]);
			}
		},

		_addPickupPoint: function (data) {
			this.pickupListCanvas.innerHTML += this.getPickupInfoHtml(data);
			setTimeout(function () {
                this._getListItemByPickupPointID(data.ID).onclick = function () {
                    if (window.__isMobile__) {
                        window.app && app.event && app.event.choosePickupPoint();
                    }
                    this.setCurrent(data);
					this.currentChanged(data);
				}.bind(this);
			}.bind(this), 0);
		},

		_getListItemByPickupPointID: function (id) {
			return document.querySelector('[id^="' + id + '"]');
		},

		getPickupInfoHtml: function () {
			throw new Error('You must define method getPickupInfoHtml!');
		},

		getNoPickupMessageHtml: function () {
			throw new Error('You must define method getNoPickupMessageHtml!');
		},

		setCurrent: function (data) {

			var itemList = this._getListItemByPickupPointID(data.ID);
			this._currentListItem && this._currentListItem.classList.remove('pickup-list__selected');

			if (itemList) {
				this._currentListItem = itemList;
				this._currentListItem.classList.add('pickup-list__selected');
			}
		},

		currentChanged: function () {
			throw new Error('You must define method currentChanged!');
		}
	}

	return list;

})(jQuery);